/**
 * Icon set — spec §F2 ("the mockup's 24x24 stroke icon set ... copy the exact path data").
 *
 * `ICONS` is copied verbatim from the mockup script's `const ICONS = {...}`; `<Icon/>`
 * is the React equivalent of its `icon(name, size = 17)` helper (same viewBox, stroke
 * width, caps and joins, `currentColor` so buttons colour their own icons).
 */
import type { CSSProperties } from 'react';

export const ICONS = {
  map: 'M9 3 4 5v16l5-2 6 2 5-2V3l-5 2-6-2zM9 3v14M15 5v14',
  chart: 'M4 20V10M10 20V4M16 20v-8M22 20H2',
  db: 'M12 3c4.4 0 8 1.3 8 3s-3.6 3-8 3-8-1.3-8-3 3.6-3 8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  wrench: 'M14.7 6.3a4.5 4.5 0 0 0-6 6L3 18l3 3 5.7-5.7a4.5 4.5 0 0 0 6-6L14 13l-3-3 3.7-3.7z',
  upload: 'M12 16V4m0 0 4 4m-4-4L8 8M4 16v4h16v-4',
  layers: 'm12 2 9 5-9 5-9-5 9-5zM3 12l9 5 9-5M3 17l9 5 9-5',
  legend: 'M4 5h4v4H4zM4 15h4v4H4zM11 7h9M11 17h9',
  basemap: 'M3 3h18v18H3zM3 9h18M9 3v18',
  home: 'm3 11 9-8 9 8v10h-6v-6h-6v6H3z',
  measure: 'm2 16 6 6L22 8l-6-6L2 16zM7 11l2 2M11 7l2 2M15 3l2 2',
  draw: 'M12 19l7-7 3 3-7 7-3-3zM18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5zM2 2l7.586 7.586M11 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  swipe: 'M12 3v18M8 8l-4 4 4 4M16 8l4 4-4 4',
  // The Animate map tool (client item 1, 2026-09-15): a filmstrip, 24×24, 2px stroke.
  film: 'M3 5h18v14H3zM3 9h4M3 15h4M17 9h4M17 15h4M7 5v14M17 5v14',
  download: 'M12 3v12m0 0 4-4m-4 4-4-4M4 17v4h16v-4',
  share: 'M18 8a3 3 0 1 0-2.8-4H15a3 3 0 0 0 .2 1.1L8.9 8.8a3 3 0 1 0 0 6.4l6.3 3.7A3 3 0 1 0 18 16l-6.3-3.7a3 3 0 0 0 0-.6L18 8z',
  x: 'M18 6 6 18M6 6l12 12',
  menu: 'M4 7h16M4 12h16M4 17h16',
  play: 'M6 4l14 8-14 8z',
  pause: 'M6 4h4v16H6zM14 4h4v16h-4z',
  lock: 'M6 11V8a6 6 0 1 1 12 0v3M5 11h14v10H5z',
  chev: 'm9 6 6 6-6 6',
  droplet: 'M12 2C8.2 7.6 5 11.2 5 15a7 7 0 1 0 14 0c0-3.8-3.2-7.4-7-13z',
  sun: 'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM12 1.5v3M12 19.5v3M4.6 4.6l2.1 2.1M17.3 17.3l2.1 2.1M1.5 12h3M19.5 12h3M4.6 19.4l2.1-2.1M17.3 6.7l2.1-2.1',
  sprout: 'M12 22V10M12 11C12 6.5 9 4 3.5 4 3.5 9.5 7 12 12 11zM12 13c0-4 3-6 8.5-6 0 5.5-3.5 7.5-8.5 6',
  cpu: 'M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3M5 5h14v14H5zM9 9h6v6H9z',
  globe: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM2 12h20M12 2c3 3.5 3 16.5 0 20-3-3.5-3-16.5 0-20z',
  shield: 'M12 2 4 5v6c0 5.5 3.8 9.7 8 11 4.2-1.3 8-5.5 8-11V5l-8-3z',
  info: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM12 8h.01M11 12h1v5h1',
  check: 'M20 6 9 17l-5-5',
  // C5's password visibility toggle. Not in the mockup's set — the mockup had no password
  // field to reveal — so these are drawn to its grammar: 24×24, 2px stroke, round caps.
  eye: 'M1.6 12S5.3 5.5 12 5.5 22.4 12 22.4 12 18.7 18.5 12 18.5 1.6 12 1.6 12zM12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z',
  eyeOff: 'M9.9 5.7A9.6 9.6 0 0 1 12 5.5c6.7 0 10.4 6.5 10.4 6.5a18 18 0 0 1-3.4 4.2M6 7.8A18 18 0 0 0 1.6 12S5.3 18.5 12 18.5c1.6 0 3-.4 4.2-.9M9.7 9.7a3.2 3.2 0 0 0 4.5 4.5M3 3l18 18',
  // The catalogue's own four (client, 2026-09-16: *"still not happy with our modernity and
  // creativity on the catalogue"*). `raster`/`vector`/`table` are the three §D4 `data_type`
  // values drawn as glyphs — a pixel grid, a polygon, a headed table — so a card and a list
  // row can say what shape a dataset is without spending a word on it; `building` heads the
  // rail's Data source group and `search` sits inside the hero's search pill. All five are
  // drawn to the mockup's grammar: 24x24, 2px stroke, round caps.
  raster: 'M3 3h18v18H3zM3 9h18M3 15h18M9 3v18M15 3v18',
  vector: 'M12 2.5 20.5 7.5v9L12 21.5 3.5 16.5v-9L12 2.5z',
  table: 'M3 4h18v16H3zM3 9h18M9 9v11M15 9v11',
  building: 'M3 21h18M5 21V7l7-4 7 4v14M9 10h2M14 10h2M9 14h2M14 14h2M10 21v-4h4v4',
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-4.3-4.3',
} as const;

export type IconName = keyof typeof ICONS;

export interface IconProps {
  name: IconName;
  /** Mockup default is 17px; the topbar nav renders at 16. */
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export function Icon({ name, size = 17, className, style }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
    >
      <path d={ICONS[name]} />
    </svg>
  );
}
